import FooterMobile from 'components/mobile/FooterMobile';
import MobileMenu from 'components/mobile/MobileMenu';
import Viewer3D from 'components/Viewer3D';
import { useZakeke } from '@zakeke/zakeke-configurator-react';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

// Container component for the mobile layout
export const Container = styled.div`
  position: relative;
  display: flex;
  flex-flow:column;
  padding:40px 60px;
  @media (max-width: 1024px) {
    flex-direction: column;
    padding:0px;
    height: 100%;
  }
  @media (min-width: 1024px) {
    width: 100%;
    height: 100%;
  }
`;

// MobileContainer component for the mobile layout
export const MobileContainer = styled.div`
  position: relative;
  display:grid;
  grid-template-rows: 1fr auto auto;
  height:100%;
  width:100%;
  overflow:hidden;
`;

// Top component for the mobile layout
export const Top = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 40%;
  min-height:0;

  @media (max-width: 1024px) {
    display:flex;
    flex-direction: column;
  }
`;

// LayoutMobile component for the mobile layout
function LayoutMobile() {
  const containerRef = useRef<HTMLDivElement>(null);
  const zakeke = useZakeke();
  const { isSceneLoading } = zakeke;
  const resizedRef = useRef(false);

  // Watch the grid container for size changes caused by children rendering.
  // When MobileMenu and FooterMobile mount, the 1fr row shrinks the viewer.
  // This observer fires after that reflow and forces the canvas to match.
  useEffect(() => {
    if (isSceneLoading || resizedRef.current) return;

    const el = containerRef.current;
    if (!el) return;

    const forceResize = (zakeke as any).forceViewerResize;
    if (!forceResize) return;

    const ro = new ResizeObserver(() => {
      forceResize();
      resizedRef.current = true;
      ro.disconnect();
    });
    ro.observe(el);

    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSceneLoading]);

  return (
    <MobileContainer ref={containerRef}>
      <Viewer3D />
      <MobileMenu />
      <FooterMobile />
    </MobileContainer>
  );
}

export default LayoutMobile;
